import React from "react";
import {
  Button,
  FlexDirectionRow,
  FormContainer,
  MainContent,
  SubTitle,
} from "../../../../../components/StyledComponents";
import "./styles.module.scss";
import { EventoSebraeService } from "../../../services/eventoSebraeService";
import { handleModalStatus } from "../../../../../utils/handleModalStatus";
import { BaSeDialogContext } from "@base/react";
import {
  maxLength,
  minLength,
  valueIsRequired,
} from "../../../../../utils/regex";
import Input from "../../../../../components/InputControlled";
import { useForm } from "react-hook-form";
import { useApp } from "../../../../../context/app";
import TextArea from "../../../../../components/TextArea";

export const IncluirEventoSebrae = () => {
  const { setRenderIncludeScreen } = useApp();
  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      nome: "",
      descricao: "",
      codigoEvento: "",
      endpoint: "",
      token: "",
      logo: "",
      urlInscricao: "",
      valor: "",
      urlMapaEvento: "",
      urlPontos: "",
      urlGaleria: "",
      urlSaibaMais: "",
      idComunidade: "",
    },
  });

  const { showModal } = React.useContext(BaSeDialogContext);

  const handleGoHome = () => {
    setRenderIncludeScreen(false);
  };

  const sendRequest = async (dataForm) => {
    try {
      const response = await EventoSebraeService.save(dataForm);
      console.log("response", response);
      handleModalStatus({
        type: "success",
        msgOnSuccess: "Evento adicionado com sucesso.",
        onCloseModal: handleGoHome,
        showModal,
      });
    } catch (e) {
      handleModalStatus({
        type: "error",
        showModal,
      });
    }
  };
  
  const onResetFields = () => {
    reset()
  }

  return (
    <MainContent>
      <SubTitle>
        <h3>Incluir</h3>
      </SubTitle>

      <FormContainer
        style={{ displayFlex: true, flexDirection: "column" }}
        onSubmit={handleSubmit(sendRequest)}
      >
        <Input
          required={true}
          maxLength={100}
          minLength={3}
          name="nome"
          control={control}
          rules={{ ...valueIsRequired(), ...maxLength(100), ...minLength(3) }}
          placeholder={"Nome do Evento"}
        />

        <TextArea
          required={true}
          minLength={3}
          name="descricao"
          control={control}
          rules={{ ...valueIsRequired(), ...minLength(3) }}
          placeholder={"Descrição do Evento"}
        />

        <Input
          required={true}
          maxLength={36}
          minLength={1}
          name="codigoEvento"
          control={control}
          rules={{ ...valueIsRequired(), ...maxLength(36), ...minLength(1) }}
          placeholder={"Código do Evento (Integração)"}
        />

        <Input
          required={true}
          maxLength={255}
          minLength={10}
          name="endpoint"
          control={control}
          rules={{ ...valueIsRequired(), ...maxLength(255), ...minLength(10) }}
          placeholder={"Endpoint (Integração)"}
        />

        <Input
          required={true}
          maxLength={255}
          minLength={10}
          name="token"
          control={control}
          rules={{ ...valueIsRequired(), ...maxLength(255), ...minLength(10) }}
          placeholder={"Token (Integração)"}
        />

        <Input
          required={true}
          maxLength={1024}
          minLength={11}
          name="logo"
          control={control}
          rules={{ ...valueIsRequired(), ...maxLength(1024), ...minLength(1) }}
          placeholder={"URL - Logo do Evento"}
        />

        <Input
          required={false}
          maxLength={1024}
          name="urlInscricao"
          control={control}
          rules={{ ...maxLength(1024) }}
          placeholder={"URL - Inscrições do Evento"}
        />

        <Input
          required={false}
          name="valor"
          type="number"
          control={control}
          placeholder={"Valor Base - Inscrição"}
        />

        <Input
          required={false}
          maxLength={1024}
          name="urlMapaEvento"
          control={control}
          rules={{ ...maxLength(1024) }}
          placeholder={"URL - Mapa do Evento"}
        />

        <Input
          required={false}
          maxLength={1024}
          name="urlPontos"
          control={control}
          rules={{ ...maxLength(1024) }}
          placeholder={"URL - Programa de Pontos"}
        />

        <Input
          required={false}
          maxLength={1024}
          name="urlGaleria"
          control={control}
          rules={{ ...maxLength(1024) }}
          placeholder={"URL - Galeria"}
        />

        <Input
          required={false}
          maxLength={1024}
          name="urlSaibaMais"
          control={control}
          rules={{ ...maxLength(1024) }}
          placeholder={"URL - Saiba Mais"}
        />

        <Input
          required={false}
          maxLength={36}
          name="idComunidade"
          control={control}
          rules={{...maxLength(36) }}
          placeholder={"ID da Comunidade - REDE SEBRAE"}
        />

        <FlexDirectionRow position={"end"} style={{ marginRight: "40px" }}>
          <Button
              type="button"
              backgroundColor={"#9CA2A8"}
              onClick={onResetFields}
              style={{
                marginRight: '20px'
              }}
          >
            Limpar
          </Button>
          
          <Button href="#" type="submit">
            Incluir Evento
          </Button>
        </FlexDirectionRow>
      </FormContainer>
    </MainContent>
  );
};
